import { faqItems } from '@/mocks/homeData';

export default function Faq() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[1024px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-100 text-center mb-3">
          常见问题
        </h2>
        <p className="text-foreground-400 text-sm text-center mb-10">
          关于80s电影网的常见疑问，这里都有答案
        </p>

        <div className="space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.q}
              className="bg-background-50 border border-background-200/30 rounded-xl overflow-hidden"
            >
              <div className="p-5 md:p-6">
                <h3 className="text-base font-bold text-foreground-100 mb-3 font-heading flex items-start gap-3">
                  <span className="text-primary-500 shrink-0 mt-0.5">
                    <i className="ri-question-answer-line"></i>
                  </span>
                  {item.q}
                </h3>
                <p className="text-sm text-foreground-400 leading-relaxed pl-8">
                  {item.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}